export const DELIVERY_TYPES = {
  UBER: 'UberDelivery',
  PEYA: 'PedidosYaDelivery',
  OWN: 'OwnDelivery',
  CABIFY: 'CabifyDelivery',
  UBER_DAAS: 'UberDaasDelivery',
  PEYA_V3: 'PedidosYaV3Delivery',
  RAPPI_CARGO: 'RappiCargoDelivery'
};

export const SNAKE_DELIVERY_TYPES = {
  OwnDelivery: 'own_delivery',
  PeyaDelivery: 'peya_delivery',
  UberDelivery: 'uber_delivery',
  CabifyDelivery: 'cabify_delivery',
  UberDaasDelivery: 'uber_daas_delivery',
  PedidosYaV3Delivery: 'peya_v3_delivery',
  RappiCargoDelivery: 'rappi_cargo_delivery'
};

export const CAMEL_DELIVERY_TYPES = {
  own_delivery: 'OwnDelivery',
  peya_delivery: 'PedidosYaDelivery',
  uber_delivery: 'UberDelivery',
  cabify_delivery: 'CabifyDelivery',
  uber_daas_delivery: 'UberDaasDelivery',
  peya_v3_delivery: 'PedidosYaV3Delivery',
  rappi_cargo_delivery: 'RappiCargoDelivery'
};

export const DELIVERY_STATUS = {
  REJECTED: 'rejected',
  EXPIRED: 'expired',
  PREORDER: 'preorder',
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
  IN_PROGRESS: 'inProgress',
  NEAR_PICKUP: 'nearPickup',
  PICKED_UP: 'pickedUp',
  NEAR_DROPOFF: 'nearDropoff',
  COMPLETED: 'completed',
  NO_DELIVERY: 'noDelivery',
  CONFIRMING: 'confirming'
};

export const DISPATCH_METHODS = {
  DELIVERY: 'store_delivery',
  PICKUP: 'in_store'
};
